import WebServiceRequest from "../../Api/WebServiceRequest";

class PlanCreate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Plan/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default PlanCreate;
